import { gql } from "@apollo/client";

const REJECT_WHATSAPP_CALL = gql`
  mutation rejectWhatsAppCall($callId: String!) {
    rejectWhatsAppCall(callId: $callId) {
      id
      callId
      status
    }
  }
`;

export default REJECT_WHATSAPP_CALL;
